module.exports = __webpack_public_path__ + "img/1440.02fdbc8b.jpg";